import { CONFIGURATION_ERRORS } from "./config";
import { configureAppStorage } from "./lib/appStorage";
import { captureDoctorInvitationSecret } from "./lib/doctorInvitationSecret";
import { legacyPatientTarget } from "./routing/surfacePaths";

// Remove bearer secrets before importing the app or initializing telemetry and
// third-party integrations. The sign-in handoff uses tab storage, never a URL.
captureDoctorInvitationSecret();

function showStartupError(title: string, description: string, errors: string[] = []) {
  const root = document.getElementById("root");
  if (!root) throw new Error("Root element with id 'root' not found");
  const alert = document.createElement("main");
  alert.setAttribute("role", "alert");
  alert.style.cssText = "max-width:48rem;margin:4rem auto;padding:1.5rem;font:1rem/1.6 system-ui;color:#172033;background:#fff;border:1px solid #aab2bf;border-radius:8px";
  const heading = document.createElement("h1");
  heading.textContent = title;
  const message = document.createElement("p");
  message.textContent = description;
  const details = document.createElement("ul");
  for (const error of errors) {
    const item = document.createElement("li");
    item.textContent = error;
    details.append(item);
  }
  alert.append(heading, message);
  if (errors.length) alert.append(details);
  root.replaceChildren(alert);
  return alert;
}

export let startup: Promise<void> | undefined;

// Do not statically import the application here: module evaluation can start
// services before this validation boundary runs.
const patientTarget = legacyPatientTarget(window.location.pathname, window.location.search, window.location.hash);
if (patientTarget !== null) {
  window.location.replace(patientTarget);
} else if (CONFIGURATION_ERRORS.length) {
  showStartupError(
    "Dashboard configuration error",
    "The dashboard could not start. Contact your administrator to correct the configuration and rebuild or restart the dashboard.",
    CONFIGURATION_ERRORS,
  );
} else {
  configureAppStorage();
  startup = import("./bootstrap").then(() => undefined).catch(() => {
    const alert = showStartupError(
      "Dashboard could not load",
      "Check your connection and reload the dashboard. If the problem continues, contact your administrator.",
    );
    const reload = document.createElement("button");
    reload.type = "button";
    reload.textContent = "Reload dashboard";
    reload.addEventListener("click", () => window.location.reload());
    alert.append(reload);
  });
}
